/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  get_applicant_hms_videos_action,
  get_applicant_submitted_assessment_kits_action,
  review_interview_kit_candidate_action,
} from "../../../../redux/_actions";

function useInterviewVideos(props) {
  const [assignedInterviewKit, setAssignedInterviewKit] = useState([]);
  const [applicantHmsVideos, setApplicantHmsVideos] = useState([]);
  const [expandedAssessmentKitId, setExpandedAssessmentKitId] = useState();
  const [expandedAssessmentKitVideos, setExpandedAssessmentKitVideos] =
    useState();
  const [interviewVideosLoading, setInterviewVideosLoading] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { applicantSubmittedAssessmentKitsData } = useSelector(
    (state) => state.get_applicant_submitted_assessment_kits_reducer
  );
  const { applicantHmsVideosData } = useSelector(
    (state) => state.get_applicant_hms_videos_reducer
  );

  const { applicantProfileData } = useSelector(
    (state) => state.get_applicant_profile_info_reducer
  );

  const { interviewKitReviewData } = useSelector(
    (state) => state.review_interview_kit_candidate_reducer
  );

  useEffect(() => {
    setInterviewVideosLoading(true);
    const callSubmittedAssessmentKitsApi = async (data) => {
      if (data?.assessment_kit_submitted === true) {
        await dispatch(
          get_applicant_submitted_assessment_kits_action(data?.id)
        );
      }
    };

    if (applicantProfileData?.data) {
      let data = applicantProfileData?.data;
      if (data?.id === parseInt(params?.id)) {
        callSubmittedAssessmentKitsApi(data);
        getHmsRoomVideos(params?.id);
      }
    }
    setInterviewVideosLoading(false);
  }, [applicantProfileData]);

  useEffect(() => {
    if (applicantSubmittedAssessmentKitsData?.data) {
      setAssignedInterviewKit(
        applicantSubmittedAssessmentKitsData?.data.results
      );
      let data = applicantSubmittedAssessmentKitsData?.data.results[0];
      if (applicantProfileData?.data?.id === parseInt(params?.id)) {
        onAssessmentKitExpandClick(data?.interview_kit);
        setExpandedAssessmentKitId(data?.interview_kit);
      }
    }
  }, [applicantSubmittedAssessmentKitsData, applicantProfileData]);
  useEffect(() => {
    if (applicantHmsVideosData?.data) {
      if (applicantProfileData?.data?.id === parseInt(params?.id)) {
        setApplicantHmsVideos(applicantHmsVideosData?.data);
      } else setApplicantHmsVideos([]);
    }
  }, [applicantHmsVideosData, applicantProfileData]);
  useEffect(() => {
    if (interviewKitReviewData?.data) {
      let data = interviewKitReviewData.data?.results;
      if (applicantProfileData?.data?.id === parseInt(params?.id)) {
        setExpandedAssessmentKitVideos(data);
      } else setExpandedAssessmentKitVideos([]);
    }
  }, [interviewKitReviewData, applicantProfileData]);

  const onAssessmentKitVideosClick = (id) => {
    navigate(
      `/view-assessment-video?interviewKit=${id}&applicant=${
        applicantProfileData?.data && applicantProfileData.data?.candidate
      }`
    );
  };
  const allInterviewKitsQuestions = (interview_kit) => {
    let count = 0;
    Array.isArray(interview_kit) &&
      interview_kit.map((item) => (count = count + item.questions.length));
    return count;
  };

  const getHmsRoomVideos = async (id) => {
    await dispatch(get_applicant_hms_videos_action(id));
  };

  const onInterviewVideosClick = (id) => {
    navigate(`/view-interview-video/${id}`);
  };
  const getJoineesNames = (hmsRoomDetail) => {
    let arr = [];
    if (hmsRoomDetail?.name) {
      if (arr[0]) arr[1] = hmsRoomDetail?.name;
      else arr[0] = hmsRoomDetail?.name;
    }
    if (hmsRoomDetail?.mentor) {
      if (arr[0]) arr[1] = hmsRoomDetail.mentor?.full_name;
      else arr[0] = hmsRoomDetail.mentor?.full_name;
    }
    if (hmsRoomDetail?.candidate) {
      if (arr[0]) arr[1] = hmsRoomDetail.candidate?.full_name;
      else arr[0] = hmsRoomDetail.candidate?.full_name;
    }
    if (hmsRoomDetail?.hiring_manager) {
      if (arr[0]) arr[1] = hmsRoomDetail.hiring_manager?.full_name;
      else arr[0] = hmsRoomDetail.hiring_manager?.full_name;
    }
    return arr;
  };

  const onAssessmentKitExpandClick = async (id) => {
    setInterviewVideosLoading(true);
    if (expandedAssessmentKitId !== id) {
      if (applicantProfileData?.data) {
        const candidateId = applicantProfileData.data?.candidate;

        setExpandedAssessmentKitId(id);
        await dispatch(
          review_interview_kit_candidate_action(id, candidateId, 1)
        );
      }
    }
    setInterviewVideosLoading(false);
  };

  return {
    assignedInterviewKit,
    expandedAssessmentKitId,
    expandedAssessmentKitVideos,
    interviewVideosLoading,
    onAssessmentKitVideosClick,

    applicantHmsVideos,
    onInterviewVideosClick,
    getJoineesNames,
    allInterviewKitsQuestions,
    onAssessmentKitExpandClick,
  };
}
export default useInterviewVideos;
